import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { UIRouterModule } from '@uirouter/angular';

import { CoreFiltersModule } from '../../core.filters.module';
import { CoreServicesModule } from '../../core.services.module';

import { CoreWidgetsModule } from '../../../widgets/core.widgets.module';
import { ProjectModule } from '../project/project.module';

import { AdminResolvesService } from './admin-resolves.service';
import { OrgHelper } from './services/admin.org-helper.service';
import { AdminSettingsService } from './services/admin.settings.service'
import { AdminHeaderService } from './services/admin.header.service';

import { AdminHeadingDropdownComponent } from './admin-heading-dropdown/admin.heading-dropdown.component';
import { AdminHeaderComponent } from './header/admin.header.component';
import { AdminChangePasswordComponent } from './change-password/admin.change-password.component';
import { AdminUserEditComponent } from './user-edit/admin.user-edit.component';
import { AdminUserAddComponent } from './user-add/admin.user-add.component';

import { KeyValueTableComponent } from './authentication/key-value-table/admin.kvtable.component';
import { AdminConfigComponent } from './config/admin.config.component';
import { AuthConfigDisplayComponent } from './authentication/auth-config-display/admin.auth-config-display.component';
import { AdminGroupViewComponent } from './groups/admin.groups.component';
import { AdminProjectsViewComponent } from './projects/admin.projects.component';

import { SiteAdminAuthViewComponent } from './authentication/admin.authentication.component';
import { SiteAdminOrgsView } from './orgs/admin.orgs.component';

import { AdminEditProjectComponent } from './projects/project-edit-modal/admin.project-edit.component';
import { AdminDeleteProjectComponent } from './projects/project-delete-modal/admin.project-delete.component';

import { SiteAdminReportSelectorComponent } from './reports/admin-reports-selector/reports.selector.component';
import { SiteAdminReportsHeaderComponent } from './reports/admin-reports-header/reports.header.component';

import { AuditReportHelper } from './reports/audit/reports.audit.service.component';
import { AdminAuditReportComponent } from './reports/audit/reports.audit.component';

import { CronReportHelper } from './reports/cron/reports.cron.service.component';
import { SiteCronHistoryComponent } from './reports/cron/reports.cron.component';

import { SiteSummaryReportComponent } from './reports/summary/reports.summary.component';

import { AdminSystemLogReportComponent } from './reports/system-log/reports.system-log.component';
import { SystemLogReportHelper } from './reports/system-log/reports.system-log.service';

import { SiteAdminScmComponent } from './scm/admin.scm.component';

import { SiteAdminHomepageComponent } from './siteAdminHomepage/site.admin.homepage.component';
import { SiteAdminHomepageHeaderComponent } from './siteAdminHomepage/siteAdminHomepageHeader/site.admin.homepage.header.component';
import { SiteAdminHomepageOptionsComponent } from './siteAdminHomepage/siteAdminHomepageOptions/site.admin.homepage.options.component';
import { AdminSiteNotificationsViewComponent } from './siteNotifications/admin.site-notifications.component';

import { AdminSnapshotsViewComponent } from './snapshots/admin.snapshots.component';

import { AdminTroveViewComponent } from './trove/admin.trove.component';
import { TroveAddModalComponent } from './trove/trove-add-modal/admin.trove-add.modal.component';
import { TroveDeleteModalComponent } from './trove/trove-delete-modal/admin.trove-delete.modal.component';
import { TroveMoveModalComponent } from './trove/trove-move-modal/admin.trove-move.modal.component';

import { AdminUsersViewComponent } from './users/admin.users.component';

import { NvD3Module } from '../../../widgets/nvd3';

import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { SiteAdminCronjobsComponent } from "./cronjobs/admin.cronjobs.component";
import { AdminAiFlowComponent } from './aiFlow/admin.ai-flow.component';
import { AdminKnowledgeIndexComponent } from './knowledgeIndex/admin.knowledge-index.component';
import { KnowledgeIndexAdminService } from '../project/admin/projectAdminKnowledgeIndex/knowledge-index-admin.service';
import { AdminWebhooksComponent } from './webhooks/admin.webhooks.component';

import { ADMIN_STATES } from './admin.module.routes';
@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NvD3Module,
        CoreWidgetsModule,
        CoreFiltersModule,
        CoreServicesModule,
        ProjectModule,
        ContextMenuModule,
        UIRouterModule.forChild({
            states: ADMIN_STATES
        })
    ],
    providers: [
        AdminResolvesService,
        OrgHelper,
        AdminSettingsService,
        AdminHeaderService,
        AuditReportHelper,
        CronReportHelper,
        SystemLogReportHelper,
        KnowledgeIndexAdminService,
    ],
    exports: [
    ],
    declarations: [
        AdminHeadingDropdownComponent,
        AdminHeaderComponent,
        AdminConfigComponent,
        AuthConfigDisplayComponent,
        KeyValueTableComponent,
        SiteAdminAuthViewComponent,
        AdminChangePasswordComponent,
        AdminUserEditComponent,
        AdminUserAddComponent,
        AdminGroupViewComponent,
        SiteAdminOrgsView,
        AdminProjectsViewComponent,
        AdminEditProjectComponent,
        AdminDeleteProjectComponent,
        SiteAdminReportSelectorComponent,
        SiteAdminReportsHeaderComponent,
        AdminAuditReportComponent,
        SiteCronHistoryComponent,
        SiteSummaryReportComponent,
        AdminSystemLogReportComponent,
        SiteAdminScmComponent,
        SiteAdminCronjobsComponent,
        SiteAdminHomepageComponent,
        SiteAdminHomepageHeaderComponent,
        SiteAdminHomepageOptionsComponent,
        AdminSiteNotificationsViewComponent,
        AdminSnapshotsViewComponent,
        AdminTroveViewComponent,
        TroveAddModalComponent,
        TroveDeleteModalComponent,
        TroveMoveModalComponent,
        AdminUsersViewComponent,
        AdminAiFlowComponent,
        AdminKnowledgeIndexComponent,
        AdminWebhooksComponent,
    ],
})
export class AdminModule {
    constructor() { }
}
